/* LAYANA OFFICIEL — theme.js (vanilla, sans dépendance) */
(function () {
  'use strict';
  var L = window.LAYANA || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var fmt = L.moneyFormat || '{{amount}} DH';
    var value = (cents / 100);
    function withDelims(n, dec, thou, sep) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.length > 1 ? parts[0] + sep + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withDelims(value, 2, ',', '.');
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_space_separator': return withDelims(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withDelims(value, 0, ' ', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }

  function toast(msg) {
    var t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-visible'); }, 2800);
  }

  /* ---------- Top bar rotative ---------- */
  $$('[data-topbar]').forEach(function (bar) {
    var msgs = $$('.topbar__msg', bar);
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4000);
  });

  /* ---------- Drawers (menu, guide des tailles) ---------- */
  var lastFocus = null;
  function openDrawer(name) {
    var d = $('[data-drawer="' + name + '"]');
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var f = $('button, a, input', $('.drawer__panel', d));
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.body.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Tri collection ---------- */
  $$('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', s.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- Compteur panier ---------- */
  function refreshCartCount() {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
      }).catch(function () {});
  }

  function addToCart(variantId, qty) {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
  }

  /* ---------- Compléter le look : ajout rapide ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    addToCart(b.getAttribute('data-quick-add'), 1).then(function () {
      b.classList.add('is-added');
      b.textContent = 'Ajouté ✓';
      var note = $('[data-look-note]');
      if (note) note.hidden = false;
      refreshCartCount();
      toast('Ajouté à votre commande');
    }).catch(function () { b.disabled = false; toast('Impossible d\'ajouter cet article.'); });
  });

  /* ---------- Recommandations produits ---------- */
  $$('[data-related]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || el.children.length) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var inner = $('[data-related]', tmp);
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    }).catch(function () {});
  });

  /* ==========================================================
     FICHE PRODUIT
     ========================================================== */
  $$('[data-product-section]').forEach(initProduct);

  function initProduct(section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var form = $('[data-product-form]', section);
    var idInput = $('[data-variant-input]', section);
    var sizeIndex = parseInt(section.getAttribute('data-size-index'), 10);
    var lowStock = parseInt(section.getAttribute('data-low-stock'), 10) || 0;
    var optionSets = $$('.option', section);
    var codButtons = $$('[data-cod-trigger]', section);
    codButtons.forEach(function (b) { var l = $('[data-cod-label]', b); b._label = l ? l.textContent : ''; });

    /* --- Galerie : points + swipe --- */
    var track = $('[data-gallery-track]', section);
    var dots = $$('[data-dot]', section);
    var slides = track ? $$('.gallery__slide', track) : [];
    if (track && dots.length) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
          ticking = false;
        });
      }, { passive: true });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          track.scrollTo({ left: track.clientWidth * parseInt(d.getAttribute('data-dot'), 10), behavior: 'smooth' });
        });
      });
    }
    function goToMedia(mediaId) {
      if (!mediaId || !track) return;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') == String(mediaId)) {
          if (window.innerWidth < 990) track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
          return;
        }
      }
    }

    /* --- Variantes --- */
    function selectedOptions() {
      return optionSets.map(function (fs) {
        var c = $('input[data-option-input]:checked', fs);
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      if (opts.indexOf(null) !== -1) return null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i], ok = true;
        for (var k = 0; k < opts.length; k++) { if (v.options[k] !== opts[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function markAvailability(opts) {
      optionSets.forEach(function (fs, idx) {
        $$('input[data-option-input]', fs).forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var possible = product.variants.some(function (v) {
            for (var k = 0; k < test.length; k++) { if (test[k] !== null && v.options[k] !== test[k]) return false; }
            return v.available;
          });
          var label = inp.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !possible);
        });
      });
    }
    function setCodState(available, missingSize) {
      codButtons.forEach(function (b) {
        var l = $('[data-cod-label]', b);
        b.disabled = !available && !missingSize;
        if (l) l.textContent = (!available && !missingSize) ? (L.strings ? L.strings.soldOut : 'Épuisé') : b._label;
      });
    }

    var currentVariant = null;
    function update(fromUser) {
      var opts = selectedOptions();
      optionSets.forEach(function (fs, i) {
        var lab = $('[data-option-label]', fs);
        if (lab) lab.textContent = opts[i] || '—';
      });
      markAvailability(opts);
      var v = product.options.length ? findVariant(opts) : product.variants[0];
      if (!optionSets.length) v = product.variants.find(function (x) { return String(x.id) === idInput.value; }) || product.variants[0];
      currentVariant = v;
      var missingSize = !v && sizeIndex > -1 && opts[sizeIndex] === null;

      if (v) {
        idInput.value = v.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (form) form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: v } }));
        var cur = $('[data-price-current]', section), cmp = $('[data-price-compare]', section), sticky = $('[data-sticky-price]', section);
        if (cur) { cur.textContent = formatMoney(v.price); cur.classList.toggle('price--sale', v.compare_at_price > v.price); }
        if (cmp) { cmp.hidden = !(v.compare_at_price > v.price); cmp.textContent = formatMoney(v.compare_at_price); }
        if (sticky) sticky.textContent = formatMoney(v.price);
        var note = $('[data-stock-note]', section);
        if (note) {
          if (v.available && v.inventory !== null && v.inventory > 0 && v.inventory <= lowStock) {
            note.textContent = (L.strings ? L.strings.lowStock : 'Plus que [qty] pièce(s)').replace('[qty]', v.inventory);
            note.hidden = false;
          } else { note.hidden = true; }
        }
        if (fromUser) {
          goToMedia(v.media_id);
          if (window.history && history.replaceState) {
            var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
            history.replaceState({}, '', url.toString());
          }
        }
        setCodState(v.available, false);
      } else {
        setCodState(false, missingSize);
      }
      if (!missingSize) clearSizeError();
    }

    function clearSizeError() {
      var fs = optionSets[sizeIndex];
      if (!fs) return;
      fs.classList.remove('is-error');
      var err = $('[data-size-error]', fs); if (err) err.hidden = true;
    }
    function showSizeError() {
      var fs = optionSets[sizeIndex];
      if (!fs) return;
      fs.classList.add('is-error');
      var err = $('[data-size-error]', fs); if (err) err.hidden = false;
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var vals = $('.option__values', fs);
      if (vals) { vals.classList.remove('shake'); void vals.offsetWidth; vals.classList.add('shake'); }
    }

    section.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) update(true);
    });

    /* --- Bouton COD → Releasit --- */
    function findReleasitButton() {
      var sel = L.releasitSelector;
      var candidates = [];
      if (sel) { try { candidates = $$(sel); } catch (err) { candidates = []; } }
      if (!candidates.length) {
        candidates = $$('button, a, div[role="button"]').filter(function (el) {
          var c = (el.className && el.className.toString ? el.className.toString() : '') + ' ' + (el.id || '');
          return /(^|[\s_-])rsi|releasit/i.test(c);
        });
      }
      candidates = candidates.filter(function (el) { return !el.hasAttribute('data-cod-trigger') && !el.closest('[data-sticky-cod]'); });
      return candidates[0] || null;
    }

    codButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var opts = selectedOptions();
        if (sizeIndex > -1 && opts[sizeIndex] === null) { showSizeError(); return; }
        if (!currentVariant || !currentVariant.available) return;

        var rsi = findReleasitButton();
        if (rsi) { rsi.click(); return; }

        /* Releasit pas encore chargé : on réessaie brièvement */
        var tries = 0;
        btn.disabled = true;
        var iv = setInterval(function () {
          tries++;
          var r = findReleasitButton();
          if (r) { clearInterval(iv); btn.disabled = false; r.click(); return; }
          if (tries > 12) {
            clearInterval(iv); btn.disabled = false;
            if (L.fallback !== false) {
              addToCart(currentVariant.id, 1)
                .then(function () { window.location.href = (L.routes && L.routes.cart) || '/cart'; })
                .catch(function () { toast('Une erreur est survenue, merci de réessayer.'); });
            } else {
              toast('Le formulaire de commande se charge, merci de réessayer.');
            }
          }
        }, 250);
      });
    });

    /* --- Barre collante --- */
    var sticky = $('[data-sticky-cod]', section);
    var inlineCod = $('.cod [data-cod-trigger]', section);
    if (sticky && inlineCod && 'IntersectionObserver' in window) {
      var footer = $('.site-footer');
      var inlineVisible = true, footerVisible = false, passed = false;
      function refresh() {
        var show = !inlineVisible && passed && !footerVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          inlineVisible = en.isIntersecting;
          passed = en.boundingClientRect.top < 0 || !en.isIntersecting;
        });
        refresh();
      }, { threshold: 0 }).observe(inlineCod);
      if (footer) new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting; refresh();
      }).observe(footer);
    }

    /* léger pulse d'invitation sur le bouton principal */
    if (inlineCod) inlineCod.classList.add('is-pulse');

    update(false);
  }
})();
